import { Document, Page, Text, View, Font } from "@react-pdf/renderer";
import { useMemo } from "react";

import { Props } from "../../ClearOrderDocument";
import { Header } from "../../ClearOrderDocument/partials/Header";
import { styles } from "../styles";
import { AdditionalInformation } from "./AdditionalInformation";
import { Options } from "./Options";
import { PatientSection } from "./PatientSection";
import { Signature } from "./Signature";

export function CommercialDocument({
  facilityLogo,
  fullAddress,
  phoneNumber,
  name,
  dateOfBirth,
  activeAbnNotice,
}: Props) {
  const procedureCodes = useMemo(() => {
    return activeAbnNotice?.documentSnapshot?.procedures.map(
      (procedure: any) => procedure.cptCode
    );
  }, [activeAbnNotice]);
  return (
    <Page size="LETTER" style={styles.page}>
      <Header
        facilityLogo={facilityLogo}
        fullAddress={fullAddress}
        phoneNumber={phoneNumber}
      />
      <View style={styles.content} wrap>
        <View style={{ ...styles.section, marginTop: 0 }}>
          <Text style={styles.title}>COMMERCIAL PAYORS / UNINSURED PAYORS</Text>
          <Text style={{ ...styles.title, fontSize: "13px", marginTop: 2 }}>
            NOTICE OF NON-COVERAGE / INSURANCE OPT OUT
          </Text>
        </View>
        <View style={{ ...styles.section, marginTop: 0 }}>
          <Text style={{ ...styles.bodyText, lineHeight: 1.2 }}>
            There are times when you may choose not to file a claim with your
            insurance or when your insurance carrier may not cover certain
            services. This form is designed to help you make an informed
            decision about whether to proceed with the services listed below.
          </Text>
          <Text
            style={{
              ...styles.bodyText,
              lineHeight: 1.2,
              fontFamily: "Helvetica-Bold",
            }}
          >
            Please read this notice thoroughly to ensure you fully understand
            your options before deciding.
          </Text>
          <PatientSection
            name={name}
            dateOfBirth={dateOfBirth}
            procedureCodes={procedureCodes}
            activeAbnNotice={activeAbnNotice}
          />
          {activeAbnNotice && <Options activeAbnNotice={activeAbnNotice} />}
          <AdditionalInformation />
          <Signature activeAbnNotice={activeAbnNotice} />
        </View>
      </View>
    </Page>
  );
}
